function highlightDefaultSwatches() {
  document.querySelectorAll('swatches-variant-picker-component').forEach(picker => {
    // Cherche le premier input disponible (pas épuisé)
    const firstAvailable = picker.querySelector('.variant-option__swatch input[data-option-available="true"]');
    if (firstAvailable) {
      firstAvailable.closest('.variant-option__button-label').classList.add('is-active');
    }
  });
}

function initProgressBar() {
  const slideshow = document.querySelector('slideshow-component');
  const scroller = document.querySelector('slideshow-slides');
  const controls = document.querySelector('.media-gallery__mobile-controls');
  if (!slideshow || !controls || !scroller) return;

  const slides = [...slideshow.querySelectorAll('slideshow-slide')];
  const total = slides.length;
  if (total === 0) return;

  controls.style.setProperty('--total-slides', total);
  controls.style.setProperty('--slide-index', 0);

  scroller.addEventListener('scroll', () => {
    const progress = scroller.scrollLeft / (scroller.scrollWidth - scroller.offsetWidth);
    const translate = progress * (total - 1) * 100;
    controls.style.setProperty('--slide-index', translate / 100);
  }, { passive: true });
}

function waitForSlideshow() {
  const slideshow = document.querySelector('slideshow-component');
  if (slideshow && slideshow.querySelectorAll('slideshow-slide').length > 0) {
    initProgressBar();
  } else {
    setTimeout(waitForSlideshow, 100);
  }
}

waitForSlideshow();

// Ré-init quand on change de variante
document.addEventListener('change', (e) => {
  if (e.target.matches('input[type="radio"][data-variant-id]')) {
    setTimeout(waitForSlideshow, 400);
  }
});

const observer = new MutationObserver(() => {
  const backdrop = document.getElementById('UpcartPopupBackDrop');
  if (backdrop && backdrop.classList.contains('styles_active__')) {
    document.body.classList.add('upcart-blur');
  } else {
    document.body.classList.remove('upcart-blur');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const target = document.getElementById('upCart') || document.body;
  observer.observe(target, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});


document.addEventListener('DOMContentLoaded', () => {
  // ============================================
  // ESTIMATED DELIVERY — HIDE WHEN OUT OF STOCK
  // ============================================

  const getAddToCartBtn = () => document.querySelector('form[action="/cart/add"] button[name="add"]');
  const getDeliveryMsg = () => document.getElementById('estimated-delivery-ATTU1SzFEcWxBb2VxQ__estimated_delivery_JVcP4C');

  const updateDeliveryVisibility = () => {
    const addToCartBtn = getAddToCartBtn();
    const deliveryMsg = getDeliveryMsg();

    if (!deliveryMsg) return;

    if (addToCartBtn && addToCartBtn.disabled) {
      deliveryMsg.style.display = 'none';
    } else {
      deliveryMsg.style.display = '';
    }
  };

  const observer = new MutationObserver(() => {
    updateDeliveryVisibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  // Vérification au chargement + délai pour laisser l'app s'injecter
  updateDeliveryVisibility();
  setTimeout(updateDeliveryVisibility, 300);
  setTimeout(updateDeliveryVisibility, 800);

  document.addEventListener('change', updateDeliveryVisibility);
});